import request from '@/utils/request'

export function updateCarCfg(data) {
  return request({
    url: 'api/v1/car-cfg/updateCarCfg',
    method: 'post',
    data: data
  })
}

export function getCarCfgList(data) {
  return request({
    url: 'api/v1/car-cfg/getCarCfg',
    method: 'post',
    data: data
  })
}

export function delCarCfg(data) {
  return request({
    url: 'api/v1/car-cfg/delCarCfg',
    method: 'post',
    data: data
  })
}

export function exportCardCfg() {
  return request({
    url: 'api/v1/car-cfg/export',
    method: 'get'
  })
}

export function importCardCfg(data) {
  return request({
    url: 'api/v1/car-cfg/import',
    method: 'post',
    data: data
  })
}
